import { Component } from 'react';
import cx from 'classnames';
class ToastMessageBox extends Component<any, any> {
  public componentDidMount() {
    if (typeof this.props.oneTapSuccessCallback === 'function') {
      this.props.oneTapSuccessCallback();
    }
  }

  public render() {
    return (
      <p className={cx('toastmessagebox', 'animated fadeInDownUp')}>
        {this.props.toastMessage}
      </p>
    );
  }
}

export default ToastMessageBox;



// WEBPACK FOOTER //
// ./components/common/toastMessageBox.tsx